/* eslint-disable */
import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import api from "../redux/api";
import logoutListener from "../redux/middleware/logoutListener";
import rtkQueryAuthGuard from "../redux/middleware/rtkQueryAuthGuard";
import appSlice from "./appSlice";
import authSlice from "./authSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    app: appSlice,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false // This is added for date issue in redux. It will be removed once the issue is fixed
    })
      .prepend(logoutListener.middleware)
      .concat(api.middleware)
      .concat(rtkQueryAuthGuard)
  ,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;